import React from 'react';

import { useAllow } from '../../components/hooks/useAllow';
import {
  PermissionTabSubrouter,
  withTabSuspense,
} from '../../components/tabs/v2/PermissionTabSubrouter';

const Users = React.lazy(() => import('../admin/users/Users'));
const Roles = React.lazy(() => import('../../roles/RolesNew'));

/**
 * Users and Roles on one page, as tabs -- the policyholder's counterpart to the
 * Cowbell console's Identity page.
 *
 * They used to be two sibling entries in the Manage menu, which asked a reader
 * to know that a role is managed separately from the people it is granted to.
 */
export const CustomerIdentitySubrouter = () => {
  const canViewUsers = useAllow(['users:view']);
  const canViewRoles = useAllow(['roles:view']);

  return (
    <PermissionTabSubrouter
      baseUrl="/customer/manage/identity"
      tabs={[
        {
          show: canViewUsers,
          path: 'users',
          label: 'Users',
          render: () => withTabSuspense(<Users />),
        },
        {
          show: canViewRoles,
          path: 'roles',
          label: 'Roles',
          render: () => withTabSuspense(<Roles />),
        },
      ]}
    />
  );
};

export default CustomerIdentitySubrouter;
